<template>
  <div class="pageContent">
    <div class="searchContent">
      <div style="height: 0.1px"></div>
      <div class="title">输入VIN码或车牌号查询</div>
      <div :class="{ myInput: true, fieldDisabled: checkType === 2 }">
        <van-field
          v-model="carData.vin"
          placeholder="请输入VIN码"
          input-align="center"
          @update:model-value="changeValue"
          maxlength="17"
          :disabled="checkType === 2"
        />
      </div>
      <div :class="{ myInput: true, fieldDisabled: checkType === 1 }">
        <van-field
          v-model="carData.plate"
          placeholder="请输入车牌号"
          input-align="center"
          @update:model-value="changeValue_plate"
          maxlength="17"
          :disabled="checkType === 1"
        />
      </div>
      <div :class="{ myInput: true, fieldDisabled: true }">
        <van-field
          v-model="carData.owner"
          placeholder="车主姓名"
          input-align="center"
          maxlength="17"
          disabled
        />
      </div>
      <div :class="{ myInput: true, fieldDisabled: true }">
        <van-field
          v-model="carData.swapCount"
          placeholder="换电次数"
          input-align="center"
          maxlength="17"
          disabled
        />
      </div>
      <div style="height: 0.1px"></div>
      <ul class="vinList" v-show="columns.length">
        <li
          v-for="(item, index) in columns"
          :key="index"
          @click="handleClick(item, 1)"
        >
          {{ item.vin }}
        </li>
      </ul>
      <ul class="vinList plateList" v-show="plateColumns.length">
        <li
          v-for="(item, index) in plateColumns"
          :key="index"
          @click="handleClick(item, 2)"
        >
          {{ item.plate }}
        </li>
      </ul>
    </div>
    <div class="button" @click="onsubmit">确认</div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
const $router = useRouter();
const $route = useRoute();
import {
  Field as vanField,
  showLoadingToast,
  closeToast,
  showToast,
} from "vant";
import { getPlate, getVinPage } from "@/views/cpCompany/api";
const carData = ref({
  vin: "",
  vehicleType: "",
  plate: "",
  swapCount: "",
  owner: "",
});
// 选中类型，1：vin；2：车牌
const checkType = ref(0);
const changeValue = (val) => {
  if (val === "") {
    checkType.value = 0;
    carData.value = {
      vin: "",
      vehicleType: "",
      plate: "",
      swapCount: "",
      owner: "",
    };
    plateColumns.value = [];
    columns.value = [];
    return;
  }
  if (val && val.length > 5) {
    getListDebounce();
  } else {
    columns.value = [];
  }
};
const changeValue_plate = (val) => {
  if (val === "") {
    checkType.value = 0;
    carData.value = {
      vin: "",
      vehicleType: "",
      plate: "",
      swapCount: "",
      owner: "",
    };
    plateColumns.value = [];
    columns.value = [];
    return;
  }
  if (val && val.length > 3) {
    getListDebounce_plate();
  } else {
    plateColumns.value = [];
  }
};
const onsubmit = async () => {
  showLoadingToast({
    message: "加载中...",
    forbidClick: true,
    duration: 0,
  });
  if (checkType.value === 1) {
    const res = await getVinPage({
      page: 1,
      size: 20,
      vin: carData.value.vin,
    });
    closeToast();
    // 检验VIN是否存在
    if (res.data.data.content?.[0]?.vin === carData.value.vin) {
      // 跳转路由
      await $router.push({
        path: "/cpCompany/monthlyCard",
        query: {
          vin: carData.value.vin,
          vehicleType: carData.value.vehicleType,
          plate: carData.value.plate,
          userPhone: $route.query.userPhone,
          userId: $route.query.userId,
        },
      });
    } else {
      showToast({
        message: "vin不存在",
        duration: 1000,
      });
    }
  } else if (checkType.value === 2) {
    const res = await getPlate({
      plate: carData.value.plate,
    });
    // 检验VIN是否存在
    if (res.data.data?.[0]?.plate === carData.value.plate) {
      closeToast();
      // 跳转路由
      await $router.push({
        path: "/cpCompany/monthlyCard",
        query: {
          vin: carData.value.vin,
          vehicleType: carData.value.vehicleType,
          plate: carData.value.plate,
          userPhone: $route.query.userPhone,
          userId: $route.query.userId,
        },
      });
    } else {
      showToast({
        message: "车牌号不存在",
        duration: 1000,
      });
    }
  } else {
    showToast({
      message: "请选择vin或者车牌号",
      duration: 1000,
    });
  }
};

const showPicker = ref("0");
const columns = ref([]);
const plateColumns = ref([]);
const debounce = (fn, time) => {
  let timer = null;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => {
      return fn.apply(this, arguments);
    }, time);
  };
};
// 防抖
const getListDebounce = debounce(() => {
  getList();
}, 1000);
const getListDebounce_plate = debounce(() => {
  getPlateList();
}, 1000);
const getList = async () => {
  if (carData.value.vin.length < 6) {
    columns.value = [];
    return;
  }
  const res = await getVinPage({
    page: 1,
    size: 20,
    vin: carData.value.vin,
  });
  const content = res.data.data.content;
  if (content.length) {
    columns.value = content;
  } else {
    columns.value = [];
  }
};
const getPlateList = async () => {
  if (carData.value.plate < 4) {
    plateColumns.value = [];
    return;
  }
  const res = await getPlate({
    plate: carData.value.plate,
  });
  const content = res.data.data;
  if (content.length) {
    plateColumns.value = content;
  } else {
    plateColumns.value = [];
  }
};
const handleClick = (item, type) => {
  carData.value.vin = item.vin;
  carData.value.vehicleType = item.vehicleType;
  carData.value.plate = item.plate;
  carData.value.swapCount = item.swapCount;
  carData.value.owner = item.owner;
  checkType.value = type;
  columns.value = [];
  plateColumns.value = [];
};
</script>

<style scoped lang="scss">
.pageContent {
  padding-top: 10.67vmin;
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(
    to bottom,
    rgba(199, 223, 253, 1),
    rgba(199, 223, 253, 0.3)
  );
}
.searchContent {
  position: relative;
  margin: 0 auto;
  padding-bottom: 5.33vmin;
  width: 93.6vmin;
  background: #ffffff;
  border-radius: 10px;
  .title {
    margin-top: 5.33vmin;
    margin-bottom: 8vmin;
    text-align: center;
    font-weight: 500;
    font-size: 4.27vmin;
    color: #10275b;
    line-height: 5.87vmin;
  }
}
.fieldDisabled {
  background: #e4e4e4 !important;
  .van-field {
    background: #e4e4e4 !important;
  }
}
.myInput {
  width: 86.13vmin;
  margin: 0 auto 5.33vmin;
  background: #e8f1fe;
  border-radius: 2.13vmin;
  border: 1px solid #d7e8fd;
  padding: 3.73vmin 0;
  .van-field {
    padding: 0;
    background: #e8f1fe;
  }
}
:deep(#van-field-1-input) {
  font-weight: 400;
  font-size: 3.73vmin;
  color: #10275b;
  line-height: 5.33vmin;
}
.button {
  width: 84vmin;
  height: 11.73vmin;
  background: #007afe;
  border-radius: 5.87vmin;
  font-weight: 400;
  font-size: 4.27vmin;
  color: #ffffff;
  line-height: 11.73vmin;
  text-align: center;
  position: fixed;
  bottom: 9.07vmin;
  left: 8vmin;
}
.myPicker {
  width: 100vw;
  position: fixed;
  bottom: 0;
  transition: all 0.5s ease;
  height: v-bind(showPicker);
}
.plateList {
  top: 55vmin !important;
}
.vinList {
  z-index: 10;
  background-color: white;
  box-shadow: 0 0.53vmin 2.67vmin 0 rgba(0, 0, 0, 0.14);
  width: 80vmin;
  border-radius: 2.67vmin;
  margin-left: 6.8vmin;
  padding-left: 2.67vmin;
  padding-right: 2.67vmin;
  box-sizing: border-box;
  position: absolute;
  top: 40vmin;
  max-height: 53vmin;
  overflow-y: auto;
  li {
    font-weight: 400;
    font-size: 3.47vmin;
    color: #10275b;
    line-height: 4.8vmin;
    padding-top: 4vmin;
    padding-bottom: 4vmin;
    border-bottom: 1px solid #e3e3e3;
  }
}
</style>
